import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    const routeNameMap = {
        'raw-materials': 'Raw Materials',
        'raw-material-inventory': 'Raw Material Inventory',
        'bom': 'Bill of Materials',
        'finished-goods': 'Finished Goods',
        'purchase-requisitions': 'Purchase Requisitions',
        'purchase-orders': 'Purchase Orders',
        'sales-orders': 'Sales Orders',
        'warehouse-locations': 'Warehouse Locations',
        'customers': 'Customers',
        'production-orders': 'Production Orders',
        'production': 'Production Tracking',
        'completed-production': 'Completed Production',
        'reports': 'Reports',
        'catalog-info': 'Catalog Info',
        'brochure-maker': 'Brochure Maker',
        'users': 'Users',
        'roles': 'Roles & Permissions',
    };

    if (pathnames.length === 0) return null;

    return (
        <nav className="flex items-center text-sm font-medium text-stone-500 mb-4" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-2">
                <li>
                    <div>
                        <Link to="/" className="text-stone-400 hover:text-indigo-600 transition-colors flex items-center">
                            <Home size={16} />
                            <span className="sr-only">Home</span>
                        </Link>
                    </div>
                </li>
                {pathnames.map((value, index) => {
                    const last = index === pathnames.length - 1;
                    const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                    const isId = value.match(/^[0-9a-fA-F]{24}$/) !== null || value.includes('-'); // Rough check for MongoDB ObjectId or SO-xxx format

                    let label = routeNameMap[value] || value;
                    if (isId && label === value) {
                        label = value.toUpperCase(); // Ensure IDs like SO-001 are uppercase
                    }

                    return (
                        <li key={to}>
                            <div className="flex items-center">
                                <ChevronRight size={16} className="text-stone-300 mx-1 shrink-0" />
                                {last ? (
                                    <span className="text-stone-800 font-semibold" aria-current="page">
                                        {label}
                                    </span>
                                ) : (
                                    <Link to={to} className="text-stone-500 hover:text-indigo-600 transition-colors">
                                        {label}
                                    </Link>
                                )}
                            </div>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumbs;
